import React, { Dispatch, Fragment, SetStateAction, useEffect, useRef, useState } from 'react';
import '../../../../assets/scss/preview.css';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import { XYZ } from 'ol/source';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Icon, Stroke, Style } from 'ol/style';
import { defaults as defaultControls } from 'ol/control';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import html2canvas from 'html2canvas';
import LineString from 'ol/geom/LineString';

const FLOOR_TMS_URL =
  import.meta.env.VITE_BUILD_MODE === 'localhost'
    ? 'https://dev.taziz4s.com/maps/tiles/{z}/{x}/{y}.png'
    : '/maps/tiles/{z}/{x}/{y}.png';

interface IProps {
  location?: any;
  onChange?: any;
  isRoadClosure?: boolean;
}

const PermitIssueMap = (props: IProps) => {
  const [isOn, setIsOn] = useState<boolean>(true);
  const [tiffLayer, setTiffLayer] = useState<any>();
  const mapElement = useRef<any>(null);
  const olMapRef = useRef<Map | null>(null);
  const [map, setMap] = useState<any>();
  const [markerLayer, setMarkerLayer] = useState<any>();
  const [base64, setBase64] = useState('');
  const timerRef = useRef(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      const sharedView = new View({
        projection: 'EPSG:4326',
        center: [52.7963177, 24.1290482],
        zoom: 15.5,
        maxZoom: 21
      });
      //
      const googleSatelliteLayer = new TileLayer({
        source: new XYZ({
          crossOrigin: 'anonymous',
          url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
        })
      });
      const tmsSource = new XYZ({
        url: FLOOR_TMS_URL
      });
      const marker1Layer = new VectorLayer({
        source: new VectorSource(),
        style: [
          new Style({
            image: new Icon({
              src: '/assets/icon/map/point.svg',
              scale: 0.5
            })
          }),
          new Style({
            stroke: new Stroke({
              color: '#4444ff',
              width: 7,
              lineCap: 'round',
              lineJoin: 'round'
            }),
            zIndex: -1
          })
        ]
      });
      //
      var _tiffLayer = new TileLayer({
        source: tmsSource
      });
      const map = new Map({
        target: mapElement.current,
        controls: defaultControls({
          zoom: false
        }),
        layers: [googleSatelliteLayer, _tiffLayer, marker1Layer],
        view: sharedView
      });
      setTiffLayer(_tiffLayer);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.___map = map;
      map.on('moveend', function () {
        captureMap(map);
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        timerRef.current = setTimeout(() => {
          captureMap(map);
        }, 3000);
      });
      olMapRef.current = map;
      setMap(map);
      setMarkerLayer(marker1Layer);
      if (props.location) {
        if(props.location.extent){
          map.getView().fit(props.location.extent, {
            padding: [0, 0, 0, 0]
          });
        }
        var source = marker1Layer.getSource();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        source.clear();
        var features = [];
        if(props.location.points){
          var points = props.location.points;
          for (var i in points) {
            const newFeature = new Feature({
              geometry: new Point(points[i])
            });
            features.push(newFeature);
          }
        }
        if(props.location.lines){
          var lines = props.location.lines;
          if (lines) {
            lines.forEach((lineCoords: any) => {
              const feature = new Feature({
                geometry: new LineString(lineCoords)
              });
              features.push(feature);
            });
          }
        }
        if(features.length > 0){
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          source.addFeatures(features);
        }
      }
    }, 100);
    return () => {
      clearTimeout(timer);
      if (olMapRef.current) {
        olMapRef.current.setTarget(undefined);
        olMapRef.current.dispose();
        olMapRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (tiffLayer) {
      tiffLayer.setVisible(isOn);
    }
  }, [isOn]);
  useEffect(() => {
    if (map && markerLayer && props.location && props.location.extent) {
      map.getView().fit(props.location.extent);
      var source = markerLayer.getSource();
      source.clear();
      var features = [];
      var points = props.location.points;
      for (var i in points) {
        const newFeature = new Feature({
          geometry: new Point(points[i])
        });
        features.push(newFeature);
      }
      var lines = props.location.lines;
      if (lines) {
        lines.forEach((lineCoords: any) => {
          const feature = new Feature({
            geometry: new LineString(lineCoords)
          });
          features.push(feature);
        });
      }

      source.addFeatures(features);
    }
  }, [props.location]);
  const captureMap = async (target: any) => {
    //return;
    var elem = target.getViewport();
    const canvas = await html2canvas(elem, {
      useCORS: true,
      allowTaint: false,
      ignoreElements: (element) => {
        return element.classList.contains('ol-control');
      }
    });
    const dataUrl = canvas.toDataURL('image/png');
    setBase64(dataUrl);
    //console.log(dataUrl);
  };
  useEffect(() => {
    if (props.onChange) {
      props.onChange({
        target: {
          name: 'locationImage',
          value: base64,
          type: 'base64'
        }
      });
    }
  }, [base64]);
  return (
    <div className={'form-map-wapper'} ref={mapElement}>
      <button
        className={'form-map-toggle-button ' + (isOn ? 'active' : '')}
        onClick={() => setIsOn(!isOn)}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="12 2 2 7 12 12 22 7 12 2" />
          <polyline points="2 17 12 22 22 17" />
          <polyline points="2 12 12 17 22 12" />
        </svg>
        {isOn ? 'ON' : 'OFF'}
      </button>
    </div>
  );
};

export default PermitIssueMap;
